// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    client1Stat: "$4M saved with optimized processes",
    client2Stat: "18x ROI achieved <br /> inthe first year",
    client3Stat: "300% increase in creative output",
    client4Stat: "55 hours saved <br /> per month <br />",
    client5Stat: "28% faster time <br /> to market",
    client6Stat: "11% efficiency gained <br /> per month",
    mainTitle: "Solutions for every team. Powered by one platform.",
    tab1ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/687362114a8e19b70c857667_Jason.png",
        alt: ""
    },
    tab1ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg",
        alt: ""
    },
    tab1ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050978/Generator_featured%20images/hp-2025/departments/bento/drive-execution-at-scale-v4.png",
        alt: "Drive execution at scale"
    },
    tab1NameClient: "Jason Doan",
    tab1QuoteClient: "“monday.com gives us the visibility to get everyone on the same page and track all the moving parts of our projects.”",
    tab1Text: "Deliver projects, programs, and portfolios with full resource visibility and AI-powered risk detection.",
    tab1TextButton: "Get Started",
    tab1Title: "Drive execution at scale",
    tab1TitleClient: "VP of Operations, HOLT CAT",
    tab2ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6873627106c54dca6fa8aeaa_Christopher.png",
        alt: ""
    },
    tab2ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860e2ec0f057ce07046a649_logo-height-kc.png",
        alt: ""
    },
    tab2ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050977/Generator_featured%20images/hp-2025/departments/bento/accelerate-revenue-growth-v4.png",
        alt: "Accelerate revenue growth"
    },
    tab2NameClient: "Christopher Stone",
    tab2QuoteClient: "\"“As a VP, trying to look at a 30,000-ft view, I can see the percentage of successful opportunities and know-how to analyze the market.”\" <br />",
    tab2Text: "Free your teams from data entry to focus on sales and nurture, with AI actions and code-free automations.",
    tab2TextButton: "Get Started",
    tab2Title: "Accelerate revenue growth",
    tab2TitleClient: "VP Business Development, KC Petroleum",
    tab3ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/65b62e80a3a89609079c247a/670ba85ec4442a965eb743d8_Vic%20Diesta.jpeg",
        alt: ""
    },
    tab3ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg",
        alt: ""
    },
    tab3ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050983/Generator_featured%20images/hp-2025/departments/bento/unify-marketing-to-amplify-impact-v4.png",
        alt: "Amplify marketing impact"
    },
    tab3NameClient: "Vic Diesta",
    tab3QuoteClient: "“monday.com isn’t just another tool in the mix, but a work operating system that supports our need for efficiency at scale.”",
    tab3Text: "Align marketing around shared goals with AI that streamlines briefs, flags delays, and drives campaign impact.",
    tab3TextButton: "Get Started",
    tab3Title: "Amplify marketing impact",
    tab3TitleClient: "Creative Operations Lead, Canva",
    tab4ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f221b5a054ab91f528af_image.png",
        alt: ""
    },
    tab4ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f49dd0c89f06fbf3217c_logo-height-zopa.png",
        alt: ""
    },
    tab4ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050985/Generator_featured%20images/hp-2025/departments/bento/scale-exceptiona-service-v4.png",
        alt: "Scale exceptional service"
    },
    tab4NameClient: "Clive Camilleri",
    tab4QuoteClient: "\"With monday service, 98% of our tickets are automatically categorized and assigned by AI. We resolve each 6-7 mins faster.\"",
    tab4Text: "Empower teams to resolve requests faster with AI that triages, routes, and guides each issue to resolution.",
    tab4TextButton: "Get Started",
    tab4Title: "Scale exceptional service",
    tab4TitleClient: "Head of People & Ops, Zopa Bank",
    tab5ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/686f8152e8fbbe7cb4f5c720_departments-headshot-6.png",
        alt: ""
    },
    tab5ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg",
        alt: ""
    },
    tab5ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050979/Generator_featured%20images/hp-2025/departments/bento/launch-quality-products-faster-v4.png",
        alt: "Launch quality products faster"
    },
    tab5NameClient: "Alan Schmoll",
    tab5QuoteClient: "\"monday dev ensures clear alignment between what we’re building and market demand. Does it help us move faster? Without a doubt.\"",
    tab5Text: "Plan roadmaps, execute sprints, and ship with precision using AI-powered guidance.",
    tab5TextButton: "Get Started",
    tab5Title: "Launch quality products faster",
    tab5TitleClient: "Executive VP, Vistra Platform",
    tab6ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6840979a2eb950be4600b697_VML-avatar.png",
        alt: ""
    },
    tab6ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg",
        alt: ""
    },
    tab6ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050981/Generator_featured%20images/hp-2025/departments/bento/lead-with-clear-foresight-v4.webp",
        alt: "Lead with clear foresight"
    },
    tab6NameClient: "Paul Willie",
    tab6QuoteClient: "“Now in real-time, we can identify health metrics and risks, whether they’re coming from our side or the client side.”",
    tab6Text: "Keep strategic goals on track with AI risk flagging and cross-org data to make real-time decisions.",
    tab6TextButton: "Get Started",
    tab6Title: "Lead with clear foresight",
    tab6TitleClient: "COO, VML"
};
